import {Trial} from '../../../model/trial';
import {OmapiIdConstants} from '../../omapi-id-constants';

export class DateUtil {
   constructor() {
  }

  static getNameOfDay(date: Date, locale: string): string {
    return date.toLocaleDateString(locale, {weekday: 'long'});
  }

  static getlocaleDate(date: Date, locale: string): string {
     return date.toLocaleDateString(locale, {day: 'numeric', month: 'long', year: 'numeric'});
  }

  static getTrialEndDate(trial: Trial): Date {
    const endDate = new Date();
    const duration: number = Number(trial.duration);
    if (trial.omapiId === OmapiIdConstants.PLAY_SPORTS_TRIAL
      || trial.omapiId === OmapiIdConstants.DAY_PASS) {
      endDate.setDate(endDate.getDate() + 1);
    } else if (trial.duration) {
      endDate.setDate(endDate.getDate() + duration);
    }
    return endDate;
  }
}
